'use client';

import { c as _c } from "react/compiler-runtime";
import { MenuIcon } from 'lucide-react';
import type { Route } from 'next';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import logo from '@/images/logo-light.svg';
const navigation = [{
  name: 'About',
  href: '/about'
},
// { name: 'Showcase', href: '/showcase' },
{
  name: 'Terms',
  href: '/legal/terms'
}, {
  name: 'Privacy Policy',
  href: '/legal/privacy'
}, {
  name: 'Contact',
  href: '/contact'
}];
export function Header() {
  const $ = _c(8);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Link href="/" className="-m-1.5 p-1.5"><span className="sr-only">Tingle Software</span><Image className="h-8 w-auto" src={logo} alt="logo" /></Link>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SheetTrigger render={<Button className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700" />}><span className="sr-only">Open main menu</span><MenuIcon className="h-6 w-6" aria-hidden="true" /></SheetTrigger>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SheetContent side="top"><MobileNavigation onOpenChange={setMobileMenuOpen} /></SheetContent>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== mobileMenuOpen) {
    t3 = <div className="flex lg:hidden"><Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>{t1}{t2}</Sheet></div>;
    $[3] = mobileMenuOpen;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="hidden lg:flex lg:gap-x-12">{navigation.map(_temp)}</div>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = <header className="bg-white"><nav className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8" aria-label="Global">{t0}{t3}{t4}</nav></header>;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}
function _temp(item) {
  return <Link key={item.name} href={item.href as Route} className="text-sm leading-6 font-semibold text-gray-900">{item.name}</Link>;
}
interface MobileNavigationProps {
  onOpenChange?: (open: boolean) => void;
}
function MobileNavigation(t0) {
  const $ = _c(15);
  const {
    onOpenChange
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== onOpenChange || $[1] !== router) {
    t1 = () => {
      router.push("/");
      onOpenChange?.(false);
    };
    $[0] = onOpenChange;
    $[1] = router;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="sr-only">Tingle Software</span>;
    t3 = <Image className="h-8 w-auto" src={logo} alt="logo" />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1) {
    t4 = <div className="flex items-center justify-between"><Link href="/" className="-m-1.5 p-1.5" onClick={t1}>{t2}{t3}</Link></div>;
    $[5] = t1;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== onOpenChange || $[8] !== router) {
    t5 = navigation.map(item => <Link key={item.name} href={item.href as Route} onClick={() => {
      router.push(item.href as Route);
      onOpenChange?.(false);
    }} className="-mx-3 block rounded-lg px-3 py-2 text-base leading-7 font-semibold text-gray-900 hover:bg-gray-50">{item.name}</Link>);
    $[7] = onOpenChange;
    $[8] = router;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <div className="mt-6 flow-root"><div className="-my-6 divide-y divide-gray-500/10"><div className="space-y-2 py-6">{t5}</div></div></div>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t6) {
    t7 = <div className="fixed inset-y-8 right-0 z-10 mt-4 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">{t4}{t6}</div>;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}